import React from 'react';
import DatePicker from './DatePicker';

import { date_icon, slot_icon, delete_file } from '../../../../../utils/images';
import { formatDate } from '../../../../../utils/date';

function DatePickerModal(props) {
	function displayRdv() {
		let arrayRDV = [];

		props?.displayRdvs?.map((rdv, index) =>
			arrayRDV.push(
				<div className="rdv-detail" key={index}>
					<span key={rdv} className="rdv-label">
						{'Rendez-vous ' + (index + 1)}
					</span>
					<span className="rdv-date">
						<img src={date_icon} alt="date icon" className="rdv-date-icon" />
						{formatDate(rdv, 'DD.MM.YYYY')}
					</span>
					<span className="rdv-slot">
						<img src={slot_icon} alt="date icon" className="rdv-slot-icon" />
						{formatDate(rdv, 'HH:mm')}
					</span>
					<span
						className="rdv-delete-icon"
						onClick={() => props?.deleteRdv(index)}
					>
						<img
							src={delete_file}
							alt="delete icon"
							className="rdv-delete-icon"
						/>
					</span>
				</div>
			)
		);
		return arrayRDV;
	}

	return (
		<div className="rdv-content">
			<DatePicker
				setSelectedDate={(date) => props?.setSelectedDate(date)}
				selectedDate={props?.selectedDate}
				desiredDays={props?.desiredDays}
			/>
			<div className="select-hour" onClick={() => props?.setShowHour(true)}>
				<div className="label-select-hour">Sélectionnez une plage horaire</div>
				<div className="icon-select-hour"></div>
			</div>
			<div className="rdv-list">{displayRdv()}</div>
			{props?.btnValidate && (
				<div
					className="choose-rdv"
					onClick={() => {
						props?.validate();
					}}
				>
					Valider mes dates souhaitées
				</div>
			)}
			<div
				className="cancel-rdv-modal"
				onClick={() => props?.setShowModal(false)}
			>
				Annuler
			</div>
		</div>
	);
}

export default DatePickerModal;
